import { InfoCard, Link } from '@backstage/core-components';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { VARIA_SLACK_CHANNEL } from '../../constants';

export const SafariNoticeCard = () => (
  <InfoCard
    title={
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
        <InfoOutlinedIcon style={{ color: '#1976d2', fontSize: 24 }} />
        Safari Browser Detected
      </span>
    }
  >
    <p>If you experience problems during login, make sure to allow popups in your browser.</p>
    <p>
      <Link to="https://support.apple.com/en-us/102524">Instructions on how to allow popups.</Link>
    </p>
    <p>
      If you still experience problems, please contact the Varia team through the{' '}
      <Link to={VARIA_SLACK_CHANNEL}>#varia Slack channel</Link>.
    </p>
  </InfoCard>
);
